import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { render } from 'react-dom';
import i18n from 'i18next';
import _ from 'lodash';
import cx from 'classnames';
import ah from './utils/ajax-helper';
import init from './utils/init';
import { changeTitle } from './components/routes';
import ResetPassword from './components/reset-password';
import Progress from './components/ui/react-ui/progress.jsx';
var lt = i18n.getFixedT(null, 'login');
var gt = i18n.getFixedT(null, 'app');
var et = i18n.getFixedT(null, 'errors');
var initialState = JSON.parse(document.getElementById('initial-state').innerHTML || '{}');
var cfg = initialState.envCfg,
    error = initialState.error;
var imageCodeReloadInterval = 60000;

var LoginClass = /*#__PURE__*/function (_Component) {
  _inherits(LoginClass, _Component);

  var _super = _createSuper(LoginClass);

  function LoginClass(props) {
    var _this2;

    _classCallCheck(this, LoginClass);

    _this2 = _super.call(this, props);
    _this2.state = {
      systemMaxPasswordFailure: 1,
      imageCode: '',
      lastImageCodeTime: -1,
      errorCode: '',
      error: '',
      userName: '',
      submitting: false,
      rememberChecked: false
    };
    _this2.handleLngChange = _this2.handleLngChange.bind(_assertThisInitialized(_this2));
    _this2.submitForm = _this2.submitForm.bind(_assertThisInitialized(_this2));
    _this2.setErrorMsg = _this2.setErrorMsg.bind(_assertThisInitialized(_this2));
    _this2.handleKeyDown = _this2.handleKeyDown.bind(_assertThisInitialized(_this2));
    _this2.handleClose = _this2.handleClose.bind(_assertThisInitialized(_this2));
    _this2.xhr = new XMLHttpRequest();

    _this2.loadImageCode();

    setInterval(function () {
      var now = new Date().getTime();
      if (_this2.state.lastImageCodeTime != -1 && now - _this2.state.lastImageCodeTime >= imageCodeReloadInterval) _this2.loadImageCode();
    }, 1000); // clear camera list in cart

    localStorage.removeItem('screenCartCameraList');
    return _this2;
  }

  _createClass(LoginClass, [{
    key: "setErrorMsg",
    value: function setErrorMsg(msg) {
      this.setState({
        error: msg
      });
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this3 = this;

      var errorObj = _.split(_.join(_.split(error, /[\s,]+/)), ',');

      _.forEach(errorObj, function (o) {
        var pair = _.split(o, ':');

        if (pair[0] == 'errorCode') {
          _this3.setState({
            errorCode: pair[1],
            error: et(pair[1])
          });
        } else if (pair[0] == 'username') {
          _this3.setState({
            userName: pair[1]
          });
        } else if (pair[0] == 'loginFailedTimes') {
          var temp = _.split(pair[1], '/');

          var remainingTimes = parseInt(temp[1]) - parseInt(temp[0]);
          if (remainingTimes > 0) _this3.setState({
            error: et('-10001-1', {
              systemMaxPasswordFailure: temp[1],
              remainingTimes: remainingTimes
            })
          });else _this3.setState({
            error: et('-10001-2', {
              systemMaxPasswordFailure: temp[1]
            })
          });
        } else if (pair[0] == 'coolDownMinutes') {
          var _temp = _.split(pair[1], '/');

          var remainingMinutes = parseInt(_temp[1]) - parseInt(_temp[0]);
          if (remainingMinutes > 0) _this3.setState({
            error: et('-10011-1', {
              remainingMinutes: remainingMinutes
            })
          });else _this3.setState({
            error: et('-10011')
          });
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loginParam1.focus();
      var isManagementMode = cfg.isManagementMode,
          guestPd = cfg.guestPd;

      if (isManagementMode === false && error === '') {
        this.loginParam1.value = 'guest';
        this.loginParam2.value = guestPd;
        this.form.submit();
      } // changeTitle(gt())

    }
  }, {
    key: "handleLngChange",
    value: function handleLngChange(e) {
      i18n.changeLanguage(e.target.value);
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      var isManagementMode = cfg.isManagementMode;

      if (isManagementMode) {
        this.setState({
          errorCode: '',
          error: '',
          userName: ''
        });
      } else {
        ah.get("".concat(cfg.contextRoot, "/logout"));
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      this.setErrorMsg('');

      if (e.keyCode === 13) {
        this.logon(e);
      }
    }
  }, {
    key: "loadImageCode",
    value: function loadImageCode() {
      var contextRoot = cfg.contextRoot;

      var _this = this;

      _this.xhr = new XMLHttpRequest();

      _this.xhr.onload = function () {
        var reader = new FileReader();

        reader.onloadend = function (e) {
          _this.setState({
            imageCode: e.target.result,
            lastImageCodeTime: new Date().getTime()
          });
        };

        if (_this.xhr.response && _this.xhr.response.size && _this.xhr.response.size > 0) reader.readAsDataURL(_this.xhr.response);
      };

      _this.xhr.open('GET', "".concat(contextRoot, "/code/image?t=").concat(new Date().getTime()));

      _this.xhr.responseType = 'blob';

      _this.xhr.send();
    }
  }, {
    key: "logon",
    value: function logon(e) {
      e.preventDefault();

      if (this.state.submitting || !this.loginParam1.value || !this.loginParam2.value || this.imageCode && !this.imageCode.value) {
        if (!this.loginParam1.value) this.setErrorMsg(lt('txt-login-account'));else if (!this.loginParam2.value) this.setErrorMsg(lt('txt-login-password'));else if (this.imageCode && !this.imageCode.value) this.setErrorMsg(lt('txt-image-code'));
        return;
      }

      this.setState({
        submitting: true
      });
      this.submitForm();
    }
  }, {
    key: "submitForm",
    value: function submitForm() {
      Progress.startSpin();
      this.form.submit();
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$state = this.state,
          imageCode = _this$state.imageCode,
          errorCode = _this$state.errorCode,
          error = _this$state.error,
          userName = _this$state.userName,
          rememberChecked = _this$state.rememberChecked;
      var contextRoot = cfg.contextRoot,
          isManagementMode = cfg.isManagementMode;
      var imgRoot = contextRoot + '/images/';
      changeTitle(null, null, isManagementMode);
      return /*#__PURE__*/React.createElement("div", {
        id: "g-login",
        className: "c-center global",
        style: {
          backgroundImage: !isManagementMode && !error ? 'none' : "url(".concat(imgRoot, "img_login_bg.png)"),
          backgroundSize: 'cover'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "company",
        title: gt('title') + ' ' + gt('title-sub'),
        style: {
          display: isManagementMode ? 'block' : 'none'
        }
      }, /*#__PURE__*/React.createElement("img", {
        className: "company-logo",
        src: imgRoot + 'logo.png'
      }), /*#__PURE__*/React.createElement("span", null, gt('title'))), /*#__PURE__*/React.createElement("div", {
        className: "login-form",
        style: {
          display: isManagementMode ? 'block' : 'none'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, lt('lbl-login')), /*#__PURE__*/React.createElement("form", {
        ref: function ref(_ref5) {
          _this4.form = _ref5;
        },
        action: "".concat(contextRoot, "/login"),
        method: "post"
      }, /*#__PURE__*/React.createElement("input", {
        ref: function ref(_ref) {
          _this4.loginParam1 = _ref;
        },
        id: "loginParam1",
        name: "loginParam1",
        type: "text",
        placeholder: lt('lbl-login-account'),
        onKeyDown: this.handleKeyDown
      }), isManagementMode ? /*#__PURE__*/React.createElement("input", {
        ref: function ref(_ref2) {
          _this4.loginParam2 = _ref2;
        },
        id: "loginParam2",
        name: "loginParam2",
        type: "password",
        autocomplete: "on",
        placeholder: lt('lbl-login-password'),
        onKeyDown: this.handleKeyDown
      }) : /*#__PURE__*/React.createElement("input", {
        ref: function ref(_ref3) {
          _this4.loginParam2 = _ref3;
        },
        id: "loginParam2",
        name: "loginParam2",
        type: "text",
        autocomplete: "on",
        placeholder: lt('lbl-login-password'),
        onKeyDown: this.handleKeyDown
      }), imageCode && /*#__PURE__*/React.createElement("div", {
        className: "imageCodeContainer"
      }, /*#__PURE__*/React.createElement("input", {
        ref: function ref(_ref4) {
          _this4.imageCode = _ref4;
        },
        id: "imageCode",
        name: "imageCode",
        type: "text",
        placeholder: lt('placeholder-image-code'),
        onKeyDown: this.handleKeyDown
      }), /*#__PURE__*/React.createElement("img", {
        className: "imageCode",
        src: imageCode,
        onClick: this.loadImageCode.bind(this)
      })), /*#__PURE__*/React.createElement("button", {
        className: "pure-button pure-button-primary",
        onClick: this.logon.bind(this)
      }, lt('lbl-login')), error && /*#__PURE__*/React.createElement("div", {
        className: cx('c-info c-error')
      }, lt(error)))), (errorCode == '-10006' || errorCode == '-10013') && userName && /*#__PURE__*/React.createElement(ResetPassword, {
        contextRoot: contextRoot,
        title: et(errorCode),
        userName: userName,
        onClose: this.handleClose
      }));
    }
  }]);

  return LoginClass;
}(Component);

init(function () {
  render( /*#__PURE__*/React.createElement(LoginClass, {
    error: error
  }), document.getElementById('app-container'));
});